/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category,2023,2024
Alpha,42,55
Beta,30,48`)
};

const es_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría,2023,2024
Alfa,42,55
Beta,30,48`)
};

const de_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category,2023,2024
Alpha,42,55
Beta,30,48`)
};

const nl_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorie,2023,2024
Alpha,42,55
Beta,30,48`)
};

const fr_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie,2023,2024
Alpha,42,55
Beta,30,48`)
};

const it_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria,2023,2024
Alpha,42,55
Beta,30,48`)
};

const pt_br2_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria,2023,2024
Alpha,42,55
Beta,30,48`)
};

const pt_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria,2023,2024
Alfa,42,55
Beta,30,48`)
};

const ja_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category,2023,2024
Alpha,42,55
Beta,30,48`)
};

const zh_bar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category,2023,2024
Alpha,42,55
Beta,30,48`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_placeholder", locale)
	if (locale === "en") return en_bar_placeholder(inputs)
	if (locale === "es") return es_bar_placeholder(inputs)
	if (locale === "de") return de_bar_placeholder(inputs)
	if (locale === "nl") return nl_bar_placeholder(inputs)
	if (locale === "fr") return fr_bar_placeholder(inputs)
	if (locale === "it") return it_bar_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_bar_placeholder(inputs)
	if (locale === "pt") return pt_bar_placeholder(inputs)
	if (locale === "ja") return ja_bar_placeholder(inputs)
	return zh_bar_placeholder(inputs)
};